import { render, staticRenderFns } from "./SkeletonOrder.vue?vue&type=template&id=72ebaad2&scoped=true&"
import script from "./SkeletonOrder.vue?vue&type=script&lang=js&"
export * from "./SkeletonOrder.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonOrder.vue?vue&type=style&index=0&id=72ebaad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebaad2",
  null
  
)

export default component.exports